import React from "react";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: "2rem",
  },
  head: {},
  break: {
    marginTop: "1rem",
  },
  gridItem: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  },
}));

const Header = (props) => {
  const { headerText } = props;
  const theme = useTheme();
  console.log(theme);
  const classes = useStyles(theme);
  return (
    <>
      <Grid className={classes.container}>
        <Grid item xs={12} className={classes.gridItem}>
          <Typography variant="h4">
            <b>{headerText}</b>
          </Typography>
        </Grid>
        <Grid className={classes.break} item xs={12}>
          <hr style={{ width: "80%" }} />
        </Grid>
      </Grid>
    </>
  );
};

export default Header;
